import VoicePolicyTextField from './VoicePolicyTextField';
import { walkthroughIds } from '../constants';

const VoicePolicyNameField = (props) => (
    <VoicePolicyTextField
        {...props}
        name="name"
        label="Voice Policy"
        placeholder="Enter voice policy name"
        walkthroughid={walkthroughIds.ufVoicePolicy}
    />
);

export default VoicePolicyNameField;
